<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',
    async created() {
        const res = await this.ajax.get('/website/admin/getWebsiteByFirmCode')
        this.$store.commit('setWebsiteInfo', res)
        localStorage.setItem('websiteInfo',JSON.stringify(res))
        document.title = res.firmName
        const ico = document.querySelector('link[rel="icon"]')||document.createElement('link')
        ico.href = res.firmLogoUrl
        let isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        this.$store.commit('setIsMobile', isMobile ? true : false)
    }
}
</script>

<style lang="scss">

#app {
    height: 100vh;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue